import { call, put, take, takeEvery } from 'redux-saga/effects'
import { UPLOAD_REQUEST, UPLOAD_STARTED, uploadProgress, uploadSuccess, uploadFailure } from './actions'
import createUploadChannel from './createUploadChannel'

export function* uploadFile(action: any): Generator<any, any, any> {
  const { key, url, file } = action
  const channel = yield call(createUploadChannel, url, file)
  yield put({ type: UPLOAD_STARTED, ...action })
  while (true) {
    const { progress = 0, error, success } = yield take(channel)
    if (error) {
      yield put(uploadFailure(key, error))
      return
    }
    if (success) {
      yield put(uploadSuccess(key))
      return
    }
    yield put(uploadProgress(key, progress))
  }
}

export default function* uploadSagas(): Generator<any, any, any> {
  yield takeEvery(UPLOAD_REQUEST, uploadFile)
}
